import React, { useState } from "react";
import { TileLayer } from "react-leaflet";

// Harita katmanları — standart (OSM) ve uydu (Esri World Imagery).
// Tüm sekmelerde aynı kontrat: TILE_LAYERS[key].{url, attribution, label}.
export const TILE_LAYERS = {
  street: {
    label: "Harita",
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution: "&copy; OpenStreetMap",
  },
  satellite: {
    label: "Uydu",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    attribution: "Tiles &copy; Esri",
  },
};

/**
 * useMapLayer — "street" | "satellite" arası seçim state'i.
 * Dönüş: [layer, setLayer]
 */
export function useMapLayer(initial = "street") {
  return useState(initial);
}

/**
 * MapLayerTile — MapContainer içine konacak TileLayer.
 * `layer` değişince key sayesinde tile katmanı yeniden bağlanır.
 */
export function MapLayerTile({ layer }) {
  const cfg = TILE_LAYERS[layer] || TILE_LAYERS.street;
  return <TileLayer key={layer} url={cfg.url} attribution={cfg.attribution} />;
}

/**
 * MapLayerToggle — Harita / Uydu geçiş butonları.
 * Haritanın üstüne (köşesine) konumlandırmak için absolute kullanılabilir.
 *
 * @param {string} value         aktif katman ("street" | "satellite")
 * @param {function} onChange    katman seçildiğinde çağrılır
 * @param {boolean} [floating]   true ise harita köşesine yapışan kapsayıcı stili
 * @param {string} [className]   ekstra sınıf(lar)
 */
export function MapLayerToggle({ value, onChange, floating = false, className = "" }) {
  const wrapper = floating
    ? "absolute top-2 right-2 z-[1000] flex gap-1 bg-white/85 backdrop-blur rounded-md p-0.5 shadow"
    : "flex justify-end gap-1";
  return (
    <div className={`${wrapper} ${className}`}>
      {Object.entries(TILE_LAYERS).map(([key, cfg]) => (
        <button
          key={key}
          type="button"
          onClick={() => onChange(key)}
          className={`text-xs rounded-md border px-2 py-1 transition-colors ${
            value === key
              ? "bg-green-600 text-white border-green-600"
              : "bg-white text-gray-600 border-gray-200 hover:bg-gray-50"
          }`}
        >
          {cfg.label}
        </button>
      ))}
    </div>
  );
}

export default MapLayerToggle;
